$(document).ready(function () {

    if (locale === 'us') {
        // USD
        pricingLookupTable = {
            0: 0,
            5000: 179,
            10000: 299,
            15000: 395,
            20000: 479,
            25000: 527,
            30000: 575,
            35000: 623,
            40000: 671,
            45000: 719,
            50000: 767,
            75000: 1007,
            100000: 1127,
            150000: 1366,
            200000: 1607
        };
    } else {
        // GBP
        pricingLookupTable = {
            0: 0,
            5000: 149,
            10000: 249,
            15000: 329,
            20000: 399,
            25000: 439,
            30000: 479,
            35000: 519,
            40000: 559,
            45000: 599,
            50000: 639,
            75000: 839,
            100000: 939,
            150000: 1139,
            200000: 1339
        };
    }
});


